// node_modules
import React, { useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

// components
import Footer from "./Footer";

// redux
import { useGetMeQuery } from "../redux/services/user";
import { setLoading } from "../redux/slices/app.slice";

// styles
import * as styles from "./PrivateRoute.module.css";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: user, isSuccess, isError } = useGetMeQuery();

  useEffect(() => {
    dispatch(setLoading(true));
  }, []);

  useEffect(() => {
    if (isError) {
      dispatch(setLoading(false));
      navigate("/login");
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess && allowedRoles.length > 0 && allowedRoles.includes(user.role))
      dispatch(setLoading(false));
  }, [isSuccess])
  
  if (
    isSuccess &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.role)
  ) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return (
    <>
      {isSuccess && (
        <div className={styles.mainWrapper}>
          {children}
          <Footer />
        </div>
      )}
    </>
  );
};

export default PrivateRoute;
